import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from "../Tabs/Tabs";
import RoomBuilderErrors from "./RoomBuilderErrors";
import RoomBuilderWorkspace from "./RoomBuilderWorkspace";

class RoomBuilder extends React.Component {
  constructor(props) {
    super(props);

    var room = this.props.room || {};
    if (this.props.connected_rooms && this.props.connected_rooms.length) {
      room.connected_room_ids = this.props.connected_rooms.map(
        (room) => room.id
      );
    }

    this.state = {
      active_tab: this.props.active_tab ? this.props.active_tab : "general",
      loading: false,
      date_format: this.props.date_format,
      time_format: this.props.time_format,
      assigned_to: this.getAssignedTo(),
      default_housekeeper: this.props.default_housekeeper,
      rooms: this.props.rooms ? this.props.rooms : {},
      is_new: this.props.is_new,
      room: room || null,
      occupancy_status: this.props.housekeeping_room
        ? this.props.housekeeping_room.occupancy_status
        : null,
      status: this.props.housekeeping_room
        ? this.props.housekeeping_room.housekeeping_status
        : null,
      housekeeping_room: this.props.housekeeping_room
        ? this.props.housekeeping_room
        : null,
      connected_rooms:
        this.props.connected_rooms && this.props.connected_rooms.length
          ? this.props.connected_rooms
          : [],
      connected_room_ids:
        this.props.connected_room_ids && this.props.connected_room_ids.length
          ? this.props.connected_room_ids
          : [],
      all_room_types: this.props.all_room_types
        ? this.props.all_room_types
        : [],
      housekeeping_endpoint: this.props.housekeeping_endpoint || null,
      room_create_path:
        this.props.room_create_path && this.props.room_create_path.length
          ? this.props.room_create_path
          : "",
      room_save_path:
        this.props.room_save_path && this.props.room_save_path.length
          ? this.props.room_save_path
          : "",
      errors: this.props.errors ? this.props.errors : {},
      ...this.props,
    };
    this.setActiveTab = this.setActiveTab.bind(this);
    this.onOwnerChange = this.onOwnerChange.bind(this);
    this.onConnectedRoomsChange = this.onConnectedRoomsChange.bind(this);
    this.onIdentifierChange = this.onIdentifierChange.bind(this);
    this.onPinCodeChange = this.onPinCodeChange.bind(this);
    this.onChangeRoomType = this.onChangeRoomType.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeHousekeeper = this.onChangeHousekeeper.bind(this);
    this.onChangeOccupancyStatus = this.onChangeOccupancyStatus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeRoomField = this.onChangeRoomField.bind(this);
    this.onSelectDevices = this.onSelectDevices.bind(this);
  }

  componentDidUpdate() {
    if (typeof initTypeahead == "function" && this.refs.root) {
      window.initTypeahead($(this.refs.root).find("[data-model][data-column]"));
    }
  }

  render() {
    var buttons = [
      {
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      },
      {
        name: I18n.t("submit"),
        button_classes: ["primary"],
        onClick: this.onSubmit,
      },
    ];

    return (
      <div className="RoomTypeBuilder">
        <Tabs
          tabs={this.tabs()}
          displayErrorMessage={
            RoomBuilderErrors.general(this.state.errors).length ||
            RoomBuilderErrors.room_type(this.state.errors).length
              ? true
              : false
          }
        />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <RoomBuilderWorkspace
            {...this.state}
            isChecked={this.isChecked}
            onIdentifierChange={this.onIdentifierChange}
            onOwnerChange={this.onOwnerChange}
            onConnectedRoomsChange={this.onConnectedRoomsChange}
            onChangeRoomType={this.onChangeRoomType}
            onChangeHousekeeper={this.onChangeHousekeeper}
            onChange={this.onChange}
            onPinCodeChange={this.onPinCodeChange}
            onChangeOccupancyStatus={this.onChangeOccupancyStatus}
            onChangeRoomField={this.onChangeRoomField}
            onSelectDevices={this.onSelectDevices}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    if (this.props.housekeeping_view == true) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "housekeeping-general",
          classes:
            this.state.active_tab === "housekeeping-general" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("housekeeping"),
          targetName: "housekeeping",
          classes: this.state.active_tab === "housekeeping" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
      ];
    } else {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.setActiveTab,
          tabErrorCount: RoomBuilderErrors.general(this.state.errors).length,
        },
        {
          tabName: I18n.t("room_types"),
          targetName: "room_types",
          classes: this.state.active_tab === "room_types" ? "active" : null,
          changeHandler: this.setActiveTab,
          tabErrorCount: RoomBuilderErrors.room_type(this.state.errors).length,
        },
        {
          tabName: I18n.t("connected_rooms"),
          targetName: "connected_rooms",
          classes:
            this.state.active_tab === "connected_rooms" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t("locks"),
          targetName: "locks",
          classes: this.state.active_tab === "locks" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
      ];
    }
  }

  setActiveTab(name) {
    this.setState({ active_tab: name });
  }

  onChangeRoomField(event) {
    var room = { ...this.state.room };
    room[event.target.name] = event.target.value;
    this.setState({
      room: room,
    });
  }

  onIdentifierChange(event) {
    var room = { ...this.state.room };
    room[event.target.name] = event.target.value;

    this.setState({
      room: room,
    });
  }

  onPinCodeChange(event) {
    var room = { ...this.state.room };
    room.pin_code = event.target.value;
    this.setState({
      room: room,
    });
  }

  onSelectDevices(devices) {
    var room = { ...this.state.room };
    room.devices = devices;
    this.setState({ room: room });
  }

  onChangeHousekeeper(housekeeper) {
    this.setState({ assigned_to: housekeeper });
  }

  onChange(event) {
    this.state[event.target.name] = event.target.value;
    this.forceUpdate();
  }
  onChangeOccupancyStatus(event) {
    this.state[event.target.name] = event.target.value;
    this.forceUpdate();
  }

  onOwnerChange(owner) {}

  onConnectedRoomsChange(connected_room_ids) {
    this.setState({
      connected_room_ids: connected_room_ids,
    });
  }

  onChangeRoomType(event) {
    var room_type_id = null;
    room_type_id = event.target.value;

    var room = { ...this.state.room };
    room.room_type_id = room_type_id;
    room.room_type_ids = [room_type_id];

    this.setState({
      room: room,
    });
  }
  onChangeHousekeepingStatus(event) {
    this.state[event.target.name] = event.target.value;
    this.forceUpdate();
  }

  getAssignedTo() {
    return this.props.assigned_to || this.props.default_housekeeper;
  }

  getDeviceParams() {
    var params = [];
    if (this.state.housekeeping_room) {
      var room = this.state.housekeeping_room
    } else {
      var room = this.state.room;
    }
    for (var i = 0, ilen = room.devices.length; i < ilen; i++) {
      const device = room.devices[i];
      params.push({
        external_id: device.external_id || device.id,
        name: device.name,
        device_type: device.type,
      });
    }
    return params;
  }

  onSubmit() {
    var self = this;
    var room = {
      id: this.state.room.id,
      identifier: this.state.room.identifier,
      floor: this.state.room.floor,
      lock_management: this.state.room.lock_management,
      owner_id: this.state.room.owner_id,
      room_type_id: this.state.room.room_type_id,
      pin_code: this.state.room.pin_code,
      devices: this.getDeviceParams(),
    };

    if (this.state.housekeeping_room) {
      var housekeepingRoom = {
        id: this.state.housekeeping_room.id,
        housekeeper_id: this.state.assigned_to
          ? this.state.assigned_to.id
          : null,
        housekeeping_status: this.state.status,
        occupancy_status: this.state.occupancy_status,
      };
    } else {
      null;
    }

    if (this.state.connected_room_ids) {
      room.connected_room_ids = this.state.connected_room_ids;
    }

    this.setState({ loading: true });
    setTimeout(() => {
      $.ajax({
        type: this.state.is_new ? "POST" : "PATCH",
        url: this.state.is_new
          ? this.state.room_create_path
          : this.state.room_save_path,
        data: {
          room: this.props.housekeeping_view ? housekeepingRoom : room,
        },
      }).done( (data) => {
        if (Object.keys(data.errors).length) {
          this.setState({ loading: false });
          this.setState({ errors: data.errors });
        } else {
          this.setState({ loading: false });
          if (parent && parent.refresh_data) {
            if (this.props.is_new == true) {
              parent.refresh_data(I18n.t("room_created_successfully"));
            } else {
              parent.refresh_data(I18n.t("room_saved_successfully"));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        }
      });
    }, 1000);
  }
}

export default RoomBuilder;
